import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    avatarUploadContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0.5rem',
    },
    avatarUploadInnerContainer: {
      position: 'relative',
    },
    uploadAvatar: {
      height: '100px',
      width: '100px',
    },
    errorContainer: {
      marginTop: '5px',
    },
    error: {
      fontSize: '0.75rem',
      color: 'red',
    },
    radioContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '5px',
    },
    radioTextContainer: {
      marginRight: '10px',
    },
    dialogPaper: {
      borderRadius: 16,
    },
    dialogHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '16px 24px',
      backgroundColor: '#f8fafc',
      borderBottom: '1px solid #eef0f3',
    },
    dialogHeaderIcon: {
      width: 44,
      height: 44,
      borderRadius: 12,
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(17, 98, 254, 0.1)',
      color: '#1162FE',
    },
    dialogTitleText: {
      fontSize: '1.15rem',
      fontWeight: 700,
      color: '#1f2937',
    },
    dialogContentContainer: {
      overflowY: 'hidden!important'
    },
    actionsContainer: {
      marginRight: '1rem',
      marginBottom: '0.5rem',
      paddingTop: '0.5rem',
    },
    editIcon: {
      position: 'absolute',
      bottom: '1px',
      right: '-5px',
      border: '1px solid rgba(0, 0, 0, 0.5)',
      borderRadius: '50%',
      height: '35px',
      width: '35px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    searchPatient: {
      marginBottom: "25px",
      width: "100%"
    }
  };
});
